import scrollToElement from "../../utils/scrollToElement";

const createInstance = () => {
  const anchorElement = document.querySelector("#pdp-complementary-products-anchor-wrapper a.pdp-cta--anchor");
  const anchorLabel = document.querySelector("#pdp-complementary-products-anchor-wrapper span.pdp-cta__text");

  const enable = () => {
    anchorElement.setAttribute('href', '#pdp-complementary-products');
    anchorElement.onclick = handleAnchorToComplementaryProducts;
    anchorLabel.classList.remove('pdp-cta__text__loading');
    anchorLabel.textContent = 'View products you may also require';
  };

  const disable = () => {
    anchorElement.parentElement.classList.add('hidden');
  };

  return {enable, disable};
};

const handleAnchorToComplementaryProducts = function(e) {
  e.preventDefault();

  const targetElement = document.getElementById("pdp-complementary-products");

  scrollToElement(targetElement);
};

export default createInstance;
